import api from "../store/services/api";

export const getEquipments = async (params) =>
  await api.get("/equipment/", { params });

export const createEquipment = async (equipment) =>
  await api.post("/equipment/", equipment, {
    headers: { "Content-Type": "application/json" },
  });

export const editEquipment = async (equipment, equipmentId) =>
  await api.put(`/equipment/?did=${equipmentId}`, equipment, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteEquipment = async (equipmentId) =>
  await api.delete(`/equipment/${equipmentId}/`);

const EquipmentsService = {
  getEquipments,
  createEquipment,
  editEquipment,
  deleteEquipment,
};

export default EquipmentsService;
